// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1RS-N","inner":"Form_inner__3aH1F","range":"Form_range__3zGAy","name":"Form_name__2Y-e6","actions":"Form_actions__1uYvb"};